import React, { Component } from 'react'

import './_shareButton.css'

class ShareButton extends Component {
  static defaultProps = {
    socialTag: undefined,
    shareAction: () => { console.log("ShareButton: 'shareAction' functino is not defined!") }
  }

  render() {

    const { onClick, className } = this.props

    return(
      <button className={`share ${className}`} onClick={onClick.bind(null, this)}></button>
    )
  }
}

export default ShareButton


// WEBPACK FOOTER //
// ./src/components/share/ShareButton.js